export default class Locale_ProjectRowMenu { 
	GroupBy = {
		ContractDefined: 'Uses the grouping, that is defined on the contract',
		ResourceRBS: "Groups by the contract's resource's RBS",
		WorkPackage: "Groups by the contract's work package",
		OriginatedRequestTemplate: 'Groups by originated request template',
		OriginatedRequestTemplateRun: 'Groups by originated request template run',
		AlignStatus: "Align status",
		ResourcePropertiesText: "Resource Properties",
		ResourcePropertiesTitle: "Group contracts by resource properties",
		ContractPropertiesText: "Contract Properties",
		ContractPropertiesTitle: "Group contracts by contracts properties",
		MiscPropertiesText: "Misc Properties",
		MiscPropertiesTitle: "Group contracts by miscellaneous properties",
		NoPropertiesWhitelistText: "No properties whitelisted",
		NoPropertiesWhitelistTitle: "No properties whitelisted by admin for, Project Capacity [[grouptype]] group by whitelist, in admin settings",
		NoMiscGroupByPropertiesAllowedText: "No miscellaneous properties allowed",
		NoMiscGroupByPropertiesAllowedTitle: "No miscellaneous properties allowed by admin for, Project Capacity in admin settings",
	}
	CustomProperties: string = 'Custom Properties';
	ResourceCustomProperty: string = `Groups by custom property: '[[displayname]] of the contract's resource`
	ContractCustomProperty: string = `Groups by custom property: '[[displayname]] of the contract`
	GroupContractsText: string = 'Group contracts by';
	GroupContractsTitle: string = 'Groups the contracts by the selected property';
}